import { render, staticRenderFns } from "./SearchHome.vue?vue&type=template&id=572237c9&scoped=true"
import script from "./SearchHome.vue?vue&type=script&lang=js"
export * from "./SearchHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572237c9",
  null
  
)

export default component.exports